/**
 * anatomy-cart-feedback.js
 *
 * 1) Checkout-return catcher. 48h session timelines showed high-intent
 *    visitors reaching Shopify checkout and bouncing back to the storefront
 *    within seconds, where nothing acknowledged their loaded cart. When a
 *    visitor returns from /checkouts/ with items in the cart, reopen the cart
 *    drawer once per session: it restates the trust stack (express wallets,
 *    guarantee, free shipping) at exactly the moment of hesitation.
 *    Covered paths: normal navigation back (referrer check) and iOS/Safari
 *    back-swipe bfcache restores (checkout-intent flag + pageshow.persisted).
 *
 * 2) PDP "in your cart" state (Baymard #624). Keeps [data-an-incart] notes in
 *    sync after AJAX adds so a second tap on Add to Cart is a decision, not a
 *    doubt about whether the first one worked.
 */
(function () {
  'use strict';
  if (window.__ANATOMY_CART_FEEDBACK__) return;
  window.__ANATOMY_CART_FEEDBACK__ = true;

  var CAUGHT_KEY = 'an_checkout_return_caught';
  var INTENT_KEY = 'an_went_checkout_at';
  var INTENT_TTL_MS = 30 * 60 * 1000;

  function ss(action, key, value) {
    try {
      if (action === 'get') return sessionStorage.getItem(key);
      if (action === 'set') sessionStorage.setItem(key, value);
      if (action === 'remove') sessionStorage.removeItem(key);
    } catch (e) { return null; }
    return null;
  }

  function openDrawerWithCart() {
    if (!document.querySelector('cart-drawer')) return; // cart page has no drawer
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.item_count) return;
        ss('set', CAUGHT_KEY, '1');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
      })
      .catch(function () {});
  }

  function maybeCatchReturn(fromBfcache) {
    if (ss('get', CAUGHT_KEY)) return;
    if (fromBfcache) {
      var ts = Number(ss('get', INTENT_KEY) || 0);
      if (!ts || Date.now() - ts > INTENT_TTL_MS) return;
      ss('remove', INTENT_KEY);
      openDrawerWithCart();
      return;
    }
    if (document.referrer && document.referrer.indexOf('/checkouts/') !== -1) {
      openDrawerWithCart();
    }
  }

  function markCheckoutIntent() {
    ss('set', INTENT_KEY, String(Date.now()));
  }

  // Every storefront path into checkout: drawer/cart "Check out" buttons,
  // direct links, and the LP direct-checkout forms.
  document.addEventListener('click', function (event) {
    var el = event.target && event.target.closest
      && event.target.closest('button[name="checkout"], a[href*="/checkout"]');
    if (el) markCheckoutIntent();
  }, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form && form.matches && form.matches('form[data-lp-redirect], form.bundle-cta__form')) {
      markCheckoutIntent();
    }
  }, true);

  function refreshInCart() {
    var notes = document.querySelectorAll('[data-an-incart]');
    if (!notes.length) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        notes.forEach(function (note) {
          var vid = note.getAttribute('data-an-incart-variant');
          var qty = 0;
          (cart.items || []).forEach(function (item) {
            if (String(item.variant_id) === vid) qty += item.quantity;
          });
          var count = note.querySelector('[data-an-incart-count]');
          if (count) count.textContent = qty;
          note.hidden = qty === 0;
        });
      })
      .catch(function () {});
  }

  document.addEventListener('ajaxProduct:added', function () {
    setTimeout(refreshInCart, 600); // let Shopify settle the cart
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { maybeCatchReturn(false); });
  } else {
    maybeCatchReturn(false);
  }
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) maybeCatchReturn(true);
  });
})();
